import produce from 'immer'

import { types } from 'common/modules/internal/actions'

export const initialState = {
    origin: null,
    messages: [],
    channel: null,
}

const reducer = (state = initialState, { type, payload }) => produce(state, (draftState) => {
    switch (type) {
        case types.INTERNAL_LISTEN:
            draftState.channel = payload.channel
            draftState.origin = payload.origin
            break
        case types.INTERNAL_RECEIVED_MESSAGE:
            draftState.messages.push(payload)
            break
        default:
    }
})

export default reducer
